import { connect } from 'react-redux';
import { compose } from 'redux';
import { setSupportContacted } from '../redux/store/appData/common';
import { State } from '../@types';
import { setIsIntercomUserRegistered } from '../redux/store/appData/common/actions';

export type Props = {
  setSupportContacted: typeof setSupportContacted;
  intercomHandlingMode: string;
  isIntercomUserRegistered: boolean;
  setIsIntercomUserRegistered: typeof setIsIntercomUserRegistered;
  xBrandId?: string | null;
};

const withSubscriber: any = compose(
  connect(
    ({
      appData: {
        common: { brandSettings, isIntercomUserRegistered },
      },
      config: { xBrandId },
    }: State) => ({
      isIntercomUserRegistered,
      intercomHandlingMode: brandSettings?.intercomHandlingMode,
      xBrandId,
    }),
    {
      setSupportContacted,
      setIsIntercomUserRegistered,
    }
  )
);
export default withSubscriber;
